export const google_api_key = "AIzaSyBKWe5Ovt5YZNBK4KAqKP31SnMKhsD6SkY";

export default google_api_key;
